import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";
import { SignUpAPI, EPromotionsAPI } from "api";
import { customSettings } from "utils/customConfig";
import { toast } from "react-toastify";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

const schema = yup.object({
  name: yup.string(),
  code: yup.string(),
  // .required("Coupon Code is required"),
  discountType: yup
    .string()
    .oneOf(["Percent", "Fixed"], "Invalid discount type")
    .required("Discount type is required"),
  value: yup
    .number()
    .typeError("Value must be a number")
    .positive("Value must be greater than zero")
    .required("Value is required"),
  validFrom: yup
    .date()
    .typeError("Valid From must be a valid date")
    .required("Valid From date is required"),
  validTo: yup
    .date()
    .typeError("Valid To must be a valid date")
    .min(yup.ref("validFrom"), "Valid To must be after Valid From")
    .required("Valid To date is required"),
  customerId: yup.string().nullable(), // Optional
  productId: yup.string().nullable(), // Optional
  usageLimit: yup
    .number()
    .typeError("Usage limit must be a number")
    .nullable()
    .min(1, "Usage limit must be at least 1"),
  usedCount: yup
    .number()
    .typeError("Used count must be a number")
    .nullable()
    .min(0, "Used count cannot be negative"),
});
// .required();

const AddPromotion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
      customerId: Number(data.customerId) || 0, // Optional field
      productId: Number(data.productId) || 0, // Optional field
    };

    // console.log(myData);

    try {
      if (location?.state) {
        setLoading(true);
        await EPromotionsAPI.post(myData);
        setLoading(false);
        toast.success("Promotion Updated Successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        setLoading(true);
        await EPromotionsAPI.post(myData);
        setLoading(false);
        toast.success("Promotion Created Successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something Went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location?.state) {
      reset(location.state);
    }
  }, [setValue]);

  return (
    <>
      <PageTitle name="E Commerce | Promotions" />
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    E Commerce | Promotions
                  </h5> */}
                  <BreadCrumbTable title="E Commerce" subTitle="Promotions" />
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <BasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddPromotion;
